import {React,useEffect} from 'react';
import Navbar from '../components/Navbar'
import Breadcrumbs from '../components/Breadcrumbs'
import Card from '../components/Card'
import Contact from "../components/Contact"
import Faq from "../components/Faq"
import InnerServices from '../components/InnerServices'
import InnerCards from '../components/InnerCards'
import InnerFaq from '../components/InnerFaq'


function BuildDocmentation() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  
  return (
    <div>
    <Breadcrumbs currentpage={"As-Built Documentation"} currentTitle={"As-Built Drawing & Drafting Professional Services"} currentcontent={"A detailed record of modifications during building process, adressing issues"} backgroundImage={"assets/img/leo/bg/12.jpg"}/>
    <section >
    <div className='container'>
      <div class="section-title">
         <h2>As Built Drawing Modeling & Documentation Services</h2>
      </div>
      <p style={{textAlign:'justify'}}>
        Our As-Built Services are designed to meet the unique needs of each of our clients, and we work closely with them to ensure that their specific requirements are met.
        <br/>
        <br/>
        As-built services refer to the process of creating updated documentation or drawings of a building or infrastructure project, reflecting any changes or modifications made during construction or installation. These updated documents are often used for maintenance, repairs, and future renovations or upgrades.
        <br/>
        <br/>
     <strong> At<span style={{color:"#FAAF3A"}}> LEO 3D </span>, we understand that the success of your construction project depends on accurate and reliable data.</strong>   That’s why we use the latest technology and techniques to ensure that <strong>our As-Built Documentation Services provide</strong> globally our clients with the most accurate and reliable data possible.
      </p>
    </div>
    </section>



    <InnerServices title="Explore Our As Built Drawing Services" paragraph="As-built services refer to documentation and drawings that accurately represent the final state of a construction project. There are several types of as-built services, including" />

    <InnerCards title={"Our Process of As Built Drawing & Documentation"} paragraph={"Our engineers offer as-built surveys for a variety of buildings, including residential, commercial, office, retail, hospitality, and more. Our process enables seamless execution of your program so that we can always provide exactly what you require."}/>

    {/* <InnerFaq /> */}

    <Contact />

    </div>
  )
}

export default BuildDocmentation